module.exports = __webpack_public_path__ + "static/media/dr-joyce-odame-dashen-opticians.7dd83b3c.jpeg";